<template>
    <div>
        <div
            class="foto"
            :data-id="photo.id"
            :data-image-id="photo.photoId"
        >
            <div
                class="img-wrapper position-relative border"
                :class="{'border-danger': error}"
            >
                <div class="img position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                    <div
                        class="loader"
                        v-show="loading"
                    ></div>
                    <canvas ref="previewCanvas"></canvas>
                </div>
                <div class="azioni-overlay position-absolute d-inline-flex justify-content-between align-items-start w-100 h-100 p-1">
                    <b-dropdown
                        variant="link p-0 text-white text-decoration-none"
                        v-show="isUploaded || error"
                    >
                        <template v-slot:button-content>
                            {{$t('Azioni')}}
                        </template>
                        <b-dropdown-item
                            v-if="!error"
                            @click="setAsCover"
                        >{{$t('Imposta come copertina')}}</b-dropdown-item>
                        <b-dropdown-item
                            v-if="!error"
                            @click="showEditNameForm"
                        >{{$t('Rinomina')}}</b-dropdown-item>
                        <b-dropdown-item
                            v-if="!error"
                            @click="edit"
                        >{{$t('Inquadra')}}</b-dropdown-item>
                        <b-dropdown-item @click="remove">{{$t('Rimuovi')}}</b-dropdown-item>
                    </b-dropdown>

                    <a
                        class="zoom-foto text-white"
                        v-show="isUploaded"
                        @click="show"
                    >
                        {{$t('Zoom')}}
                    </a>
                </div>
            </div>
            <p class="mb-0 mt-1 text-center">
                <b-row>
                    <b-col class="p-0">
                        <span
                            class="titolo-foto small"
                            v-show="!isEditingName"
                        >{{photo.name}}</span>
                    </b-col>
                    <b-col
                        sm="2"
                        v-if="error"
                        class="p-0"
                    >
                        <b-button
                            variant="link"
                            class="p-0 text-danger"
                            @click="retryUpload"
                        >
                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-input-group
                            size="sm"
                            v-show="isEditingName"
                        >
                            <b-form-input
                                required
                                v-model="photo.name"
                                @change="onChangeName"
                                @keyup="save"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    size="sm"
                                    variant="success"
                                    @click="save"
                                >
                                    <font-awesome-icon :icon="['fas', 'check']" />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GalleryPhotoPreview",
    props: ["photo"],

    data() {
        return {
            isEditingName: false,
            loading: true
        };
    },

    computed: {
        isUploaded() {
            return (
                this.photo &&
                this.photo.photoId &&
                this.photo.photoId.length > 0
            );
        },

        error() {
            return (
                this.photo.lresProgress === -1 || this.photo.hresProgress === -1
            );
        }
    },

    mounted() {
        this.drawImageOnCanvas();
    },

    methods: {
        drawImageOnCanvas() {
            if (this.isUploaded && this.$refs.previewCanvas) {
                var previewCanvasW =
                    this.$refs.previewCanvas.parentElement.clientWidth;
                var previewCanvasH =
                    this.$refs.previewCanvas.parentElement.clientHeight;
                var newPreviewCanvasW, newPreviewCanvasH;
                if (this.photo.targetRatio > 1) {
                    newPreviewCanvasW = previewCanvasW;
                    newPreviewCanvasH = previewCanvasW / this.photo.targetRatio;
                    if (newPreviewCanvasH > previewCanvasH) {
                        newPreviewCanvasH = previewCanvasH;
                        newPreviewCanvasW =
                            newPreviewCanvasH * this.photo.targetRatio;
                    }
                } else {
                    newPreviewCanvasH = previewCanvasH;
                    newPreviewCanvasW = previewCanvasH * this.photo.targetRatio;
                    if (newPreviewCanvasW > previewCanvasW) {
                        newPreviewCanvasW = previewCanvasW;
                        newPreviewCanvasH =
                            newPreviewCanvasW * this.photo.targetRatio;
                    }
                }
                this.$refs.previewCanvas.width = newPreviewCanvasW;
                this.$refs.previewCanvas.height = newPreviewCanvasH;
                this.$imagesService.drawImageOnCanvas(
                    this.photo,
                    this.$refs.previewCanvas
                );
                this.loading = false;
            }
        },

        setAsCover() {
            this.$emit("setAsCover", this.photo);
        },

        showEditNameForm() {
            this.isEditingName = true;
        },

        onChangeName(value) {
            var hasSuffix = value.slice(-4) === ".jpg";
            var maxLength = hasSuffix ? 96 : 100;
            if (value.length > maxLength) {
                value = value.slice(0, maxLength - 1);
                if (hasSuffix) {
                    value += ".jpg";
                }
            }
            this.photo.name = value;
        },

        save() {
            if (
                event.type === "click" ||
                (event.type === "keyup" && event.key === "Enter")
            ) {
                if (this.photo.name && this.photo.name.length > 0) {
                    this.$emit("save", this.photo);
                }
            }
        },

        edit() {
            this.$emit("edit", this.photo);
        },

        remove() {
            this.$emit("remove", [this.photo.photoId]);
        },

        show() {
            this.$emit("show", this.photo);
        },

        retryUpload() {
            if (this.photo.lresProgress === -1) {
                this.$emit("retryUploadLowRes", this.photo.id);
            } else {
                if (this.photo.hresProgress === -1) {
                    this.$emit("retryUploadHighRes", this.photo.id);
                }
            }
        }
    }
};
</script>

<style scoped>
.loader {
    color: black;
    margin: 50% auto; /*100px auto;*/
    font-size: 0.5rem; /*25px;*/
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: absolute;
    text-indent: -9999em;
    -webkit-animation: load5 1.1s infinite ease;
    animation: load5 1.1s infinite ease;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
}
@-webkit-keyframes load5 {
    0%,
    100% {
        box-shadow: 0em -2.6em 0em 0em #5e5e5e,
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.5),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.7);
    }
    12.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.7),
            1.8em -1.8em 0 0em #5e5e5e, 2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.5);
    }
    25% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.5),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.7), 2.5em 0em 0 0em #5e5e5e,
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    37.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.5),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.7), 1.75em 1.75em 0 0em #5e5e5e,
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    50% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.5),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.7), 0em 2.5em 0 0em #5e5e5e,
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    62.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.5),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.7), -1.8em 1.8em 0 0em #5e5e5e,
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    75% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.5),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.7), -2.6em 0em 0 0em #5e5e5e,
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    87.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.5),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.7), -1.8em -1.8em 0 0em #5e5e5e;
    }
}
@keyframes load5 {
    0%,
    100% {
        box-shadow: 0em -2.6em 0em 0em #5e5e5e,
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.5),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.7);
    }
    12.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.7),
            1.8em -1.8em 0 0em #5e5e5e, 2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.5);
    }
    25% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.5),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.7), 2.5em 0em 0 0em #5e5e5e,
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    37.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.5),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.7), 1.75em 1.75em 0 0em #5e5e5e,
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    50% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.5),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.7), 0em 2.5em 0 0em #5e5e5e,
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.2),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    62.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.5),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.7), -1.8em 1.8em 0 0em #5e5e5e,
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    75% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.5),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.7), -2.6em 0em 0 0em #5e5e5e,
            -1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2);
    }
    87.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(94, 94, 94, 0.2),
            1.8em -1.8em 0 0em rgba(94, 94, 94, 0.2),
            2.5em 0em 0 0em rgba(94, 94, 94, 0.2),
            1.75em 1.75em 0 0em rgba(94, 94, 94, 0.2),
            0em 2.5em 0 0em rgba(94, 94, 94, 0.2),
            -1.8em 1.8em 0 0em rgba(94, 94, 94, 0.5),
            -2.6em 0em 0 0em rgba(94, 94, 94, 0.7), -1.8em -1.8em 0 0em #5e5e5e;
    }
}
</style>
